/**
 * Narrow an unknown thrown value to the `{ code, message }` shape PostgREST
 * and supabase-js errors carry, so back-office pages can branch on SQLSTATE
 * without `any`. Anything else degrades to its string form.
 *
 * Codes the deal back-office branches on:
 *   P0002 no_data_found · 23514 check_violation · 42501 insufficient_privilege
 *   55000 object_not_in_prerequisite_state
 */
export function getPgError(err: unknown): { code?: string; message: string } {
  if (typeof err === 'object' && err !== null) {
    const candidate = err as { code?: unknown; message?: unknown };
    return {
      code: typeof candidate.code === 'string' ? candidate.code : undefined,
      message: typeof candidate.message === 'string' ? candidate.message : 'Unknown error',
    };
  }
  return { message: String(err) };
}
